import { type ChatbotBuilderConfiguration } from '@src/types/chatbot';
import { type LoaderFunction, redirect } from 'react-router-dom';
import { Paths } from '@src/config/paths';
import { getConfigurationForEdit } from '@src/features/chatbot/api/configurationService';

export type ChatbotBuilderViewLoaderData = {
  jobId: string;
  chatbotConfig: ChatbotBuilderConfiguration;
};

export const chatbotBuilderViewLoader = (async ({
  params,
}): Promise<ChatbotBuilderViewLoaderData | Response> => {
  const { jobId } = params;
  if (!jobId) {
    return redirect(Paths.JOBS);
  }

  let chatbotConfig: ChatbotBuilderConfiguration;
  try {
    chatbotConfig = await getConfigurationForEdit(jobId);
    if (!chatbotConfig.useChatbotBuilder) {
      return redirect(Paths.JOBS);
    }
  } catch {
    return redirect(Paths.JOBS);
  }
  return { jobId, chatbotConfig };
}) satisfies LoaderFunction;
